import { useMsal } from "@azure/msal-react";
import React from "react";
import { useEffectOnce } from "usehooks-ts";

import { GetPageTitle } from "../../support/ScrollToTop";
import { clearProof } from "../twoStep/twoStepStorage";

export const SignOutView: React.FC<unknown> = () => {
  useEffectOnce(() => {
    document.title = GetPageTitle("Sign out");
  });

  const { instance: msalInstance } = useMsal();
  // Two-step sign-in: the next person on this computer must enter their code.
  // (The 30-day "remember this computer" token is kept on purpose.)
  clearProof();

  msalInstance.logoutRedirect({
    postLogoutRedirectUri: "/",
  });

  return null;
};
